import type { PanelId } from "@/entities/section";

export const PANELS: PanelId[] = ["help", "media", "school"];

export const ANIM_DURATION_MS = 350;

export const TILE_TRANSITION =
  "background-color 0.25s ease, color 0.25s ease, border-color 0.25s ease";

export const SECTION_HOVER_RGBA: Record<string, string> = {
  help: "rgba(6,155,147,0.55)",
  school: "rgba(17,146,230,0.55)",
  media: "rgba(255,94,14,0.55)",
};

export const CSS_VAR_HOVER_RGBA: Record<string, string> = {
  "var(--group)": "rgba(87,183,69,0.55)",
  "var(--help)": "rgba(6,155,147,0.55)",
  "var(--school)": "rgba(17,146,230,0.55)",
  "var(--media)": "rgba(255,94,14,0.55)",
};

export const EASE = "cubic-bezier(0.22,1,0.36,1)";

export const TILE_TR = `top ${ANIM_DURATION_MS}ms ${EASE}, left ${ANIM_DURATION_MS}ms ${EASE}, width ${ANIM_DURATION_MS}ms ${EASE}, height ${ANIM_DURATION_MS}ms ${EASE}, border-radius 0.3s ease`;
